<template>
  <Main>
    <template v-slot:toolbar>
      <div class="white">
        <StepToolbar
          class="max-content-width"
          :steps="toolbarSteps"
          :current-step="currentStep"
        />
      </div>
    </template>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <fragment v-if="model">
      <v-row class="mb-md-2">
        <v-col cols="12" sm="4" md="6" xl="8">
          <h3 class="gray--text mb-4 mb-md-0">
            GRUPO ECONÔMICO: {{ groupName }}
          </h3>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="3"
          xl="2"
          class="pr-sm-5"
          v-if="hasHistoricButton"
        >
          <BaseButton
            outlined
            color="blue"
            class="mb-8 mb-md-0"
            width="100%"
            :to="{ name: 'economic_group credit_limit historic' }"
          >
            HISTÓRICO
          </BaseButton>
        </v-col>
        <v-col cols="12" sm="4" md="3" xl="2" v-if="hasButtonRenovation">
          <BaseButton
            class="success mb-8 mb-md-0 white--text"
            width="100%"
            @click="showModalRenovation"
          >
            RENOVAR
          </BaseButton>
        </v-col>
      </v-row>
      <v-form ref="form" @submit.prevent="submit">
        <component
          :is="step"
          :value="model"
          :credit-limit-statuses="creditLimitStatuses"
          :modality-model="currentModalityModel"
          :limit-credit="model.valor_limite_credito"
          :sub-modality-model="currentSubModalityModel"
          :modalities="listModality"
          :relationship-contacts="itemsRelationshipContacts"
          :struture-ccg="itemsStrutureCCG"
          :users="itemsUsers"
          :approval-rules="itemsApprovalRules"
          :prize-rules="itemsPrizeRules"
          :contacts-error-message="contactsErrorMessage"
          :document-error-message="documentErrorMessage"
          :modality-error-message="modalityErrorMessage"
          :submodality-error-message="submodalityErrorMessage"
          :limit-credit-modality-error-message="limitCreditModalityErrorMessage"
          :limit-credit-sub-modality-error-message="
            limitCreditSubModalityErrorMessage
          "
          :approver-value-n1-error-message="approverValueN1ErrorMessage"
          :approver-value-n2-error-message="approverValueN2ErrorMessage"
          :rule-approver="ruleApprover"
          :companies="itemsCompany"
          :is-edit="isEdit"
          @save-step="saveStep"
          @next-step="nextStep"
          @cancel="previousPage"
        />
      </v-form>
    </fragment>
    <ModalAddSubModality
      v-model="modalAddSubmodality"
      @close="closeModalAddSubmodality"
    />
    <ModalRenovation v-model="modalRenovation" @close="closeModalRenovation" />
    <ModalDeadlineRenovation
      v-if="modalDeadlineRenovation"
      v-model="modalDeadlineRenovation"
      @close="closeModalDeadlineRenovation"
      :form="model"
    />
    <ModalCancelCreditLimit
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
    <ModalCancelModalityCreditLimit
      @close="closeModalEdit"
      v-model="modalCancelEdit"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ConfigureLimit from "./credit_limit/steps/ConfigureLimit.vue";
import _ from "lodash";
import {
  formatDateToDDMMYYYY,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import ModalAddSubModality from "../components/ModalAddSubModality";
import CompanyMixin from "@/mixins/CompanyMixin";
import PolicyMixin from "@/mixins/PolicyMixin";
import ModalRenovation from "../components/ModalRenovation";
import ModalDeadlineRenovation from "../components/ModalDeadlineRenovation";
import ModalCancelCreditLimit from "../../insurance_company/components/ModalCancelInsurance";
import ModalCancelModalityCreditLimit from "../../insurance_company/components/ModalCancelInsurance";
import ConfigureModalitySection from "./credit_limit/steps/ConfigureModalitySection.vue";
import FormMixin from "@/mixins/FormMixin";
const toolbarSteps = [
  {
    name: "1. Seguradora",
    step: 1
  },
  {
    name: "2. Adicionar Modalidade",
    step: 2
  }
];
const MOCK_MODALITY = {
  ativo: true,
  modalidade: null,
  valor_limite_credito: 0,
  valor_maximo_apolice: 0,
  valor_sem_ccg: 0,
  percentual_taxa: null,
  percentual_comissao: null,
  tipo_regra_premio: null,
  valor_minimo_premio: 0,
  valor_premio: 0,
  percentual_premio: null,
  tabela_premio: {
    valores: []
  },
  submodalidades: []
};
const MOCK_SUBMODALITY = {
  ativo: true,
  submodalidade: null,
  prazo_cobertura_de: 0,
  prazo_cobertura_ate: 0,
  prazo_minuta_dias: null,
  prazo_apolice_dias: null,
  valor_limite_credito: 0,
  valor_maximo_apolice: 0,
  valor_sem_ccg: 0,
  percentual_taxa: null,
  percentual_comissao: null,
  tipo_regra_premio: null,
  valor_minimo_premio: 0,
  valor_premio: 0,
  percentual_premio: null,
  tabela_premio: {
    valores: []
  }
};
const defaultApprovalRule = {
  id: "nenhuma",
  nome: "NENHUMA"
};
const MOCK_MODEL = {
  aprovadores_n1: null,
  aprovadores_n2: null,
  ccg_arquivo: null,
  contatos_relacionamento: null,
  final_validade: null,
  inicio_validade: null,
  modalidades: null,
  percentual_comissao: null,
  pode_renovar: false,
  tem_historico: false,
  tipo_regra_aprovacao: defaultApprovalRule,
  valor_emissao_sem_ccg: null,
  valor_ilimitado_n1: false,
  valor_ilimitado_n2: false,
  valor_limite_credito: null,
  valor_limite_maximo_n1: null,
  valor_limite_maximo_n2: null
};
const MOCK_COVERAGE_SUBMODALITY = {
  administrativa: {
    prazo_cobertura_de: 1,
    prazo_cobertura_ate: 5
  },
  judicial_civil: {
    prazo_cobertura_de: 1,
    prazo_cobertura_ate: 5
  },
  judicial_recursal: {
    prazo_cobertura_de: 3,
    prazo_cobertura_ate: 5
  },
  judicial_trabalhista: {
    prazo_cobertura_de: 3,
    prazo_cobertura_ate: 5
  },
  judicial_tributaria: {
    prazo_cobertura_de: 1,
    prazo_cobertura_ate: 5
  },
  parcelamento_administrativo_fiscal: {
    prazo_cobertura_de: 1,
    prazo_cobertura_ate: 5
  },
  outras_judicial: {
    prazo_cobertura_de: 1,
    prazo_cobertura_ate: 5
  }
};
      
export default {
  beforeRouteLeave(to, from, next) {
    if (this.cancel || (this.formIsPristineCommon(this.model, this.cloneModel) && !this.coBrokeringEdit)) {
      next();
      this.setCoBrokering(null);
    }
      
    this.modalCancel = true;
    this.nextRoute = to;
  },
  name: "ConfigureConsultLimit",
  mixins: [LoadingRequest, CompanyMixin, PolicyMixin, FormMixin],
  components: {
    ConfigureLimit,
    ModalAddSubModality,
    ModalRenovation,
    ModalCancelCreditLimit,
    ModalCancelModalityCreditLimit,
    ConfigureModalitySection,
    ModalDeadlineRenovation
  },
  data() {
    return {
      breadcrumb: [
        {
          text: "Seguradora",
          to: "economic_group view"
        }
      ],
      step: ConfigureLimit,
      firstStep: ConfigureLimit,
      submitStep: ConfigureModalitySection,
      modalityState: {
        currentModality: null,
        currentSubModality: null,
        modalities: {}
      },
      model: null,
      formatDDMMYYYYToIsoDate,
      formatDateToDDMMYYYY,
      contactsErrorMessage: [],
      documentErrorMessage: [],
      modalityErrorMessage: [],
      isEdit: false,
      currentModalityModel: {},
      currentSubModalityModel: {},
      submodalityErrorMessage: [],
      modalAddSubmodality: false,
      listModality: [],
      listSubModality: [],
      modalRenovation: false,
      isRenovation: false,
      limitCreditModalityErrorMessage: [],
      limitCreditSubModalityErrorMessage: [],
      modalCancel: false,
      cancel: false,
      nextRoute: null,
      modalCancelEdit: false,
      toolbarSteps,
      modalDeadlineRenovation: false,
      cloneModel: null,
      approverValueN1ErrorMessage: [],
      approverValueN2ErrorMessage: [],
      coBrokeringEdit: null
    };
  },
  mounted() {
    const pipeline = !this.economicGroup
      ? this.findEconomicGroup(this.groupId)
      : Promise.resolve(this.economicGroup);
    pipeline.then(this.fetchData);
  },
  computed: {
    ...mapState("economic_group", [
      "economicGroup",
      "creditLimitConsult",
      "creditLimitStatuses",
      "itemsRelationshipContacts",
      "itemsStrutureCCG",
      "itemsUsers",
      "itemsApprovalRules",
      "itemsPrizeRules",
      "itemsModality",
      "itemsCompany",
      "coBrokering"
    ]),
    ...mapState("me", ["userAreaIsGarantia"]),
    groupId() {
      return this.$route.params.groupId;
    },
    consultId() {
      return this.$route.params.consultId;
    },
    groupName() {
      const { nome } = this.economicGroup || { nome: "" };
      return nome;
    },
    hasHistoricButton() {
      return (
        this.step == this.firstStep && this.model && this.model.tem_historico
      );
    },
    hasButtonRenovation() {
      return (
        this.step == this.firstStep &&
        this.model &&
        this.model.pode_renovar &&
        !this.isRenovation
      );
    },
    currentStep() {
      return this.step == this.firstStep ? toolbarSteps[0] : toolbarSteps[1];
    },
    editLimitSuccessMessage() {
      return this.userAreaIsGarantia ? "Limite foi editado com sucesso" : "Seguradora editada com sucesso";
    }
  },
  methods: {
    ...mapActions("economic_group", [
      "findEconomicGroup",
      "findCreditLimitConsult",
      "listCreditLimitStatuses",
      "requestRelationshipContacts",
      "requestStrutureCCG",
      "requestSuggestUsers",
      "requestApprovalRules",
      "requestPrizeRules",
      "requestModalityAccordingInsurance",
      "requestCompaniesAccordingEconomicGroup",
      "updateCreditLimit",
      "renewCreditLimit",
      "setCoBrokering"
    ]),
    ...mapActions(["showAlertNotification"]),
    previousPage() {
      this.limitCreditModalityErrorMessage = [];
      this.limitCreditSubModalityErrorMessage = [];

      if (this.step == this.firstStep || this.cancel == true) {
        this.$router.push({
          name: "economic_group credit_limit list",
          params: { groupId: this.groupId }
        });
      } else if (this.step == this.submitStep) {
        this.previousStep();
      } else {
        this.modalCancelEdit = true;
      }
    },
    showModalRenovation() {
      this.isRenovation = true;
      this.modalRenovation = true;
    },
    closeModalDeadlineRenovation(value) {
      this.modalDeadlineRenovation = false;
      if (value) {
        this.submit();
      } else {
        this.isRenovation = false;
      }
    },
    closeModalRenovation(value) {
      this.modalRenovation = false;
      // Se não for aceito utilizar os mesmo valores na renovação
      // o formulário será resetado, se não, será feita a requisição
      // para renovação
      if (value) {
        this.modalDeadlineRenovation = true;
      } else {
        const newModel = this.mergeProperties(
          _.cloneDeep(MOCK_MODEL),
          _.cloneDeep(this.creditLimitConsult)
        );
        this.updateModel(newModel);
      }
    },
    nextStep(item, type) {
      if (type == "modality") {
        this.isEdit = Boolean(item);
        this.currentModalityModel = item ? item : _.cloneDeep(MOCK_MODALITY);
        this.step.nextStep().then(step => (this.step = step));
      } else {
        if (item) {
          // Quando veem do back-end os valores tudo null,
          // é preciso dar merge com o mock para evitar erro
          this.currentSubModalityModel = this.mergeProperties(
            _.cloneDeep(item),
            _.cloneDeep(MOCK_SUBMODALITY)
          );
          // Caso item.ativo for false, acaba sendo substituindo pelo
          // MOCK_SUBMODALITY que é true, porém ele tem que se manter false
          this.currentSubModalityModel.ativo = _.cloneDeep(item.ativo);
          this.step.nextStep().then(step => (this.step = step));
        } else {
          this.modalAddSubmodality =
            this.$refs.form.validate() && this.validLimitCreditModality();
        }
      }
    },
    validateStepModality() {
      const model = this.currentModalityModel;
      // Valida o valor mínimo do prêmio
      if (model.utiliza_valor_minimo_premio) {
        if (
          model.tipo_regra_premio.id === "unico" &&
          model.valor_minimo_premio > model.valor_premio
        ) {
          this.limitCreditModalityErrorMessage = [
            "O valor do prêmio fixo deve ser maior, ou igual, ao valor de prêmio mínimo"
          ];
          return false;
        }
      }

      return (
        this.$refs.form.validate() &&
        this.validLimitCreditModality() &&
        this.validateSubModality()
      );
    },
    validateStepSubModality() {
      // Valida o valor mínimo do prêmio
      const model = this.currentSubModalityModel;
      if (model.utiliza_valor_minimo_premio) {
        if (
          model.tipo_regra_premio.id === "unico" &&
          model.valor_minimo_premio > model.valor_premio
        ) {
          this.limitCreditSubModalityErrorMessage = [
            "O valor do prêmio fixo deve ser maior, ou igual, ao valor de prêmio mínimo"
          ];
          return false;
        }

        // se for do tipo judicial_recursal e do tipo tabela, valida os valores da tabela
        if (
          model.tipo_regra_premio.id === "tabela" &&
          model.submodalidade.id === "judicial_recursal"
        ) {
          for (let i = 0; i < model.tabela_premio.valores.length; i++) {
            const valorImportanciaSegurada =
              model.tabela_premio.valores[i].valor_importancia_segurada;

            if (valorImportanciaSegurada < model.valor_minimo_premio) {
              this.limitCreditSubModalityErrorMessage = [
                "Os valores da importância segurada devem ser maiores, ou iguais, ao valor de prêmio mínimo"
              ];
              return false;
            }

            const prazos = model.tabela_premio.valores[i].prazos;

            for (let j = 0; j < prazos.length; j++) {
              const valorPremioPrazo = prazos[j].valor_premio;

              if (valorPremioPrazo < model.valor_minimo_premio) {
                this.limitCreditSubModalityErrorMessage = [
                  "Os valores nos anos de cobertura devem ser maiores, ou iguais, ao valor de prêmio mínimo"
                ];
                return false;
              }
            }
          }
        }
      }

      return this.$refs.form.validate() && this.validLimitCreditSubModality();
    },
    validateSubModality() {
      this.submodalityErrorMessage =
        this.currentModalityModel.submodalidades.length > 0
          ? []
          : ["É preciso adicionar pelo menos uma submodalidade"];
      return this.currentModalityModel.submodalidades.length > 0;
    },
    validLimitCreditModality() {
      this.limitCreditModalityErrorMessage =
        this.currentModalityModel.valor_limite_credito <=
        this.model.valor_limite_credito
          ? []
          : [
              `Valor de limite de crédito deve ser abaixo do definido pela seguradora de ${this.model.valor_limite_credito}`
            ];
      return (
        this.currentModalityModel.valor_limite_credito <=
        this.model.valor_limite_credito
      );
    },
    validLimitCreditSubModality() {
      this.limitCreditSubModalityErrorMessage =
        this.currentSubModalityModel.valor_limite_credito <=
        this.currentModalityModel.valor_limite_credito
          ? []
          : [
              `Valor de limite de crédito deve ser abaixo do definido pela modalidade de ${this.currentModalityModel.valor_limite_credito}`
            ];
      return (
        this.currentSubModalityModel.valor_limite_credito <=
        this.currentModalityModel.valor_limite_credito
      );
    },
    previousStep() {
      this.step.previousStep().then(step => (this.step = step));
    },
    saveStep(type) {
      if (type == "form") {
        if (!this.validateForm()) return;
        this.step.nextStep().then(step => (this.step = step));
      } else if (type == "modality") {
        if (!this.validateStepModality()) return;
        if (this.isEdit) {
          const index = this.model.modalidades.findIndex(
            x =>
              (x.id && x.id == this.currentModalityModel.id) ||
              (x.tomador == this.currentModalityModel.tomador &&
                x.modalidade == this.currentModalityModel.modalidade)
          );
          this.model.modalidades[index] = this.currentModalityModel;
        } else {
          this.model.modalidades.push(this.currentModalityModel);
        }
        this.step.previousStep().then(step => (this.step = step));
      } else {
        if (!this.validateStepSubModality()) return;
        const index = this.currentModalityModel.submodalidades.findIndex(
          x =>
            x.submodalidade.nome ==
            this.currentSubModalityModel.submodalidade.nome
        );
        this.currentModalityModel.submodalidades[
          index
        ] = this.currentSubModalityModel;
        this.step.previousStep().then(step => (this.step = step));
      }
    },
    validateForm() {
      return (
        this.$refs.form.validate() &&
        this.validateContacts() &&
        this.validateLimitApprovers()
      );
    },
    ruleApprover() {
      return (
        (this.model.status.id === "aprovado" ||
          this.model.status.id === "expirado") &&
        this.model.tipo_regra_aprovacao.id !== "nenhuma"
      );
    },
    validateLimitApprovers() {
      return (
        !this.ruleApprover() ||
        (this.ruleIntervalValueNn(1) && this.ruleIntervalValueNn(2))
      );
    },
    ruleIntervalValueNn(n) {
      const limit = this.model["valor_limite_maximo_n" + n.toString()];
      const rule =
        Boolean(this.model["valor_ilimitado_n" + n.toString()].id) ||
        (limit > 0 && limit < 1000000000000);
      this[`approverValueN${n.toString()}ErrorMessage`] = rule
        ? []
        : ["O valor deve estar entre 0 e 1000000000000"];
      return rule;
    },
    validateContacts() {
      this.contactsErrorMessage =
        this.model.contatos_relacionamento.length > 0
          ? []
          : ["É preciso adicionar pelo menos um contato de relacionamento"];
      return this.model.contatos_relacionamento.length > 0;
    },
    validateDocument() {
      this.documentErrorMessage =
        this.model.ccg_arquivo.length > 0
          ? []
          : ["É preciso adicionar um arquivo ccg"];
      return this.model.ccg_arquivo.length > 0;
    },
    validateModality() {
      this.modalityErrorMessage =
        this.model.modalidades.length > 0
          ? []
          : ["É preciso adicionar pelo menos uma modalidade"];
      return this.model.modalidades.length > 0;
    },
    getCoBrokeringPayload(coBrokering) {
      let result = {
        ativo: coBrokering.ativo,
        items:[]
      };

      if(coBrokering.ativo) {
        for(let i = 0; i < coBrokering.items.length; i++) {
          result.items.push(
            {
              corretora: coBrokering.items[i].corretora.value,
              participacao: coBrokering.items[i].participacao
            }
          );
        }
      }

      return result;
    },
    async submit() {
      if (!this.validateModality()) {
        return;
      }
      const { groupId, consultId, model } = this;
      let payload = await this.getPayloadLimit(model);
      payload.co_corretagem = this.getCoBrokeringPayload(this.coBrokering);

      if (this.isRenovation) {
        this.withLoading(
          this.renewCreditLimit({ groupId, consultId, payload })
            .then(() => {
              this.showAlertNotification({
                message: "Limite renovado com sucesso!",
                type: "success"
              });
              this.cancel = true;
              this.previousPage();
            })
            .catch(error => {
              this.showAlertNotification({
                message: !error.response
                  ? "Ocorreu um erro no sistema"
                  : error.response.data.details &&
                    error.response.data.details.length > 0
                  ? error.response.data.details.reduce(
                      (acc, { message }) => acc.concat(message),
                      ""
                    )
                  : error.response.data.error_description,
                type: "error"
              });
              this.isRenovation = false;
            })
        );
      } else {
        this.withLoading(
          this.updateCreditLimit({ groupId, consultId, payload }).then(() => {
            this.showAlertNotification({
              message: this.editLimitSuccessMessage,
              type: "success"
            });
            this.cancel = true;
            this.previousPage();
          })
        );
      }
    },
    async getPayloadLimit(item) {
      const payload = _.cloneDeep(item);
      payload.status_alterado_em = this.formatDDMMYYYYToIsoDate(
        payload.status_alterado_em
      );
      payload.solicitado_em = this.formatDDMMYYYYToIsoDate(
        payload.solicitado_em
      );
      payload.inicio_validade = this.formatDDMMYYYYToIsoDate(
        payload.inicio_validade
      );
      payload.final_validade = this.formatDDMMYYYYToIsoDate(
        payload.final_validade
      );
      payload.ccg_arquivo = await this.submitFiles(payload.ccg_arquivo);
      payload.ccg_arquivo = payload.ccg_arquivo[0];
      payload.valor_ilimitado_n2 = payload.valor_ilimitado_n2.id;
      payload.valor_ilimitado_n1 = payload.valor_ilimitado_n1.id;
      return payload;
    },
    fetchData() {
      const { groupId, consultId } = this;
      this.withLoading(
        Promise.all([
          this.findCreditLimitConsult({ groupId, consultId }),
          this.requestStrutureCCG(),
          this.listCreditLimitStatuses(),
          this.requestApprovalRules(),
          this.requestPrizeRules()
        ])
      );
    },
    updateModel(value) {
      this.model = _.cloneDeep(value);
      this.model.ccg_arquivo = value.ccg_arquivo
        ? [_.cloneDeep(value.ccg_arquivo)]
        : [];
      this.model.contatos_relacionamento = !this.model.contatos_relacionamento
        ? []
        : this.model.contatos_relacionamento;
      this.model.modalidades = !this.model.modalidades
        ? []
        : this.model.modalidades;
      this.model.valor_limite_maximo_n1 = !this.model.valor_limite_maximo_n1
        ? 0
        : this.model.valor_limite_maximo_n1;
      this.model.valor_limite_maximo_n2 = !this.model.valor_limite_maximo_n2
        ? 0
        : this.model.valor_limite_maximo_n2;
      this.model.valor_limite_credito = !this.model.valor_limite_credito
        ? 0
        : this.model.valor_limite_credito;
      this.model.valor_emissao_sem_ccg = !this.model.valor_emissao_sem_ccg
        ? 0
        : this.model.valor_emissao_sem_ccg;
      this.model.status_alterado_em = this.formatDateToDDMMYYYY(
        this.model.status_alterado_em
      );
      this.model.solicitado_em = this.formatDateToDDMMYYYY(
        this.model.solicitado_em
      );
      this.model.inicio_validade = this.model.inicio_validade
        ? this.formatDateToDDMMYYYY(this.model.inicio_validade)
        : this.model.inicio_validade;
      this.model.final_validade = this.model.final_validade
        ? this.formatDateToDDMMYYYY(this.model.final_validade)
        : this.model.final_validade;
      this.model.aprovadores_n1 = !this.model.aprovadores_n1
        ? []
        : this.model.aprovadores_n1;
      this.model.aprovadores_n2 = !this.model.aprovadores_n2
        ? []
        : this.model.aprovadores_n2;
      this.model.valor_ilimitado_n2 = this.model.valor_ilimitado_n2
        ? { id: true, nome: "SIM" }
        : { id: false, nome: "NÃO" };
      this.model.valor_ilimitado_n1 = this.model.valor_ilimitado_n1
        ? { id: true, nome: "SIM" }
        : { id: false, nome: "NÃO" };
      this.model.tipo_regra_aprovacao =
        this.model.tipo_regra_aprovacao || defaultApprovalRule;
      this.cloneModel = _.cloneDeep(this.model);
    },
    fetchItemsWithCreditLimit(value) {
      const filter = `?estrutura_id=cliente&grupo_economico_id=${value.grupo_economico.id}`;
      this.withLoading(
        Promise.all([
          this.requestRelationshipContacts(value.seguradora.id),
          this.requestSuggestUsers(filter),
          this.requestModalityAccordingInsurance(value.seguradora.id),
          this.requestCompaniesAccordingEconomicGroup(value.grupo_economico.id)
        ])
      );
    },
    closeModalAddSubmodality(value) {
      this.modalAddSubmodality = false;
      const index = this.listModality.findIndex(
        x => x.id == this.currentModalityModel.modalidade.id
      );
      const modalityMerge = _.pick(_.cloneDeep(this.currentModalityModel), [
        "valor_limite_credito",
        "valor_maximo_apolice",
        "valor_sem_ccg",
        "percentual_taxa",
        "percentual_comissao",
        "tipo_regra_premio",
        "valor_minimo_premio",
        "valor_premio",
        "percentual_premio",
        "tabela_premio",
        "tomador"
      ]);
      this.listSubModality[index].forEach(item => {
        let mockAccordingModality = _.cloneDeep(MOCK_SUBMODALITY);
        // para submodalidades da judicial, o prazo será diferenciado conforme a submodaldiade
        if (this.currentModalityModel.modalidade.id == "judicial") {
          mockAccordingModality.prazo_cobertura_de =
            MOCK_COVERAGE_SUBMODALITY[item.submodalidade.id].prazo_cobertura_de;
          mockAccordingModality.prazo_cobertura_ate =
            MOCK_COVERAGE_SUBMODALITY[
              item.submodalidade.id
            ].prazo_cobertura_ate;
        }
        const newValue = value
          ? this.mergeProperties(
              _.cloneDeep(modalityMerge),
              this.mergeProperties(
                _.cloneDeep(item),
                _.cloneDeep(mockAccordingModality)
              )
            )
          : this.mergeProperties(
              _.cloneDeep(item),
              _.cloneDeep(mockAccordingModality)
            );
        this.currentModalityModel.submodalidades.push(newValue);
      });
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    },
    closeModalEdit(value) {
      this.modalCancelEdit = false;
      if (value) this.previousStep();
    }
  },
  watch: {
    creditLimitConsult(value) {
      this.updateModel(value);
      this.fetchItemsWithCreditLimit(value);
      this.breadcrumb = [
        {
          text: `Seguradora ${value.seguradora.nome}`,
          to: "economic_group view"
        }
      ];
    },
    itemsModality(value) {
      this.listModality = _.map(value, "modalidade");
      this.listSubModality = _.map(value, "submodalidades");
    },
    coBrokering: {
      handler: function() {
        // primeira vez q disparar é a atribuição inicial:
        if(this.coBrokeringEdit === null)
        {
          this.coBrokeringEdit = false;
        }
        else {
          this.coBrokeringEdit = true;
        }
      },
      deep: true
    }
  }
};
</script>
